import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { maybeApplyCallback } from '@shared/utils/maybeApplyCallback';
import { useGetEventPhotoByEventHandleQuery } from '@graphql/generated';
import { ReactComponent as IconCamera } from '@assets/icons/icon-camera-2.svg';

type EventPhotoProps = Readonly<{
  handleOnAddPhotosClick: () => void;
  eventHandle: string;
  addPhotoText: string;
}>;

export const EventPhoto = ({ addPhotoText, eventHandle, handleOnAddPhotosClick }: EventPhotoProps) => {
  const { data, loading } = useGetEventPhotoByEventHandleQuery({
    variables: {
      website: eventHandle,
    },
    batchMode: 'fast',
  });
  const photoUrl = data?.eventByName?.photo?.url;
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
      borderRadius="100%"
      backgroundColor="gray3"
      __css={{
        width: [pxToRem(71), null, pxToRem(104)],
        height: [pxToRem(71), null, pxToRem(104)],
        minWidth: [pxToRem(71), null, pxToRem(104)],
        minHeight: [pxToRem(71), null, pxToRem(104)],
        flexShrink: 0,
        ...(photoUrl
          ? {
              backgroundImage: `url('${photoUrl}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }
          : {}),
      }}
      cursor={!photoUrl && !loading ? 'pointer' : undefined}
      onClick={maybeApplyCallback(!photoUrl && !loading, handleOnAddPhotosClick)}
    >
      {!photoUrl && (
        <Flex
          cursor="pointer"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <IconCamera />
          <TextV2
            fontSize="12px"
            marginTop={1}
          >
            {addPhotoText}
          </TextV2>
        </Flex>
      )}
    </Box>
  );
};
